var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 21.4153L12.3674 21.4544C15.1295 8.38285 36.2712 -8.03704 56.0745 12.0317C38.5309 -10.603 11.4461 2.24984 7.5 21.4153Z",
    fill: "#F15A29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1755 21.5453L54.9774 21.5773C52.5952 10.3035 38.0587 0.759907 23.4512 8.33681C34.6593 -0.943608 55.036 5.47391 59.1755 21.5453Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65234 38.2988L13.5197 38.2596C15.4315 45.9272 32.4727 60.9672 51.9352 47.3854C34.6171 63.1402 13.5659 51.7775 8.65234 38.2988Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0179 36.9383L53.8197 36.9062C50.3565 47.3852 34.9306 54.1583 23.7988 47.6768C35.3478 56.4807 53.3546 49.5279 58.0161 36.9383H58.0179Z",
    fill: "#F15A29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54102 33.7407C2.54102 34.2955 2.99012 34.7453 3.54396 34.7453C4.0978 34.7453 4.54691 34.2955 4.54691 33.7407C4.54691 33.1859 4.0978 32.7324 3.54396 32.7324C2.99012 32.7324 2.54102 33.1859 2.54102 33.7407Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65417 30.5335C8.06954 29.7102 7.4021 29.5679 7.4021 29.5679L3.44712 28.2201C2.21874 27.7542 2.16016 28.7073 2.16016 28.7073L2.19743 31.5649L6.91571 31.6573L7.65417 30.5353V30.5335ZM3.43115 28.894H3.04594C3.04594 28.894 2.92346 28.8851 2.93234 29.0576C2.94121 29.2301 2.93234 29.6337 2.93234 29.6337C2.93234 29.6337 2.94476 29.8027 2.79033 29.8187C2.79033 29.8187 2.62169 29.8525 2.60571 29.68L2.59684 28.9402C2.59684 28.9402 2.63056 28.6042 2.98736 28.6042H3.44002C3.44002 28.6042 3.65481 28.6042 3.64949 28.7642C3.64061 28.9242 3.43115 28.894 3.43115 28.894Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98219 35.9613H2.55737C2.55737 35.9613 1.28993 36.0236 1.28993 34.7379L1.25265 30.3013C1.25265 30.3013 1.06804 28.6707 2.10471 27.8349C2.10471 27.8349 2.91062 26.8178 4.40705 26.9014L15.5584 26.6027V26.3626L5.44194 26.0354C5.44194 26.0354 4.30586 26.0354 5.1739 25.1943L6.71648 23.7664C6.71648 23.7664 7.54192 23.0356 9.30816 23.1103L17.298 22.8418L17.2678 22.527L17.0832 22.543L8.33895 22.5341C8.33895 22.5341 6.95435 22.3652 6.09519 23.3699L3.70055 25.7402C3.70055 25.7402 3.03843 26.0265 3.08458 25.3206C3.08458 25.3206 3.45025 24.3088 2.59819 23.9727C2.59819 23.9727 1.09289 23.393 0.425443 24.1487C0.425443 24.1487 -0.61833 25.2192 0.563903 25.4966L1.88992 25.9163C1.88992 25.9163 2.97275 26.215 2.10294 26.7698C2.10294 26.7698 0.194677 27.6482 0.265682 29.9919L0.434319 35.9738C0.434319 35.9738 0.178701 38.0329 2.01063 37.8853L5.36561 37.8551C5.36561 37.8551 6.83719 37.9938 6.80879 36.3098L16.485 36.0324V35.7728L6.54075 35.5666C6.54075 35.5666 5.98691 35.9578 4.98041 35.9578L4.98219 35.9613Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98739 33.5879L6.97852 34.1178L15.2364 33.8404L6.98739 33.5879Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1352 32.9783L6.97852 32.877L6.99449 33.3642L15.1352 32.9783Z",
    fill: "#414042"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31203 34.9801L15.238 34.74L7.29428 34.5266C6.5647 34.5942 6.66588 33.9167 6.66588 33.9167V32.4799L14.8031 32.0176L6.1511 32.0265L6.13867 34.3239C6.15997 35.0921 7.3138 34.9801 7.3138 34.9801H7.31203Z",
    fill: "#414042"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7006 30.4788L8.39177 30.0254L7.29297 31.7645L14.7006 31.5884L8.09 31.327L8.24621 31.1048L14.6917 30.9963L8.42195 30.8185L8.59768 30.5251L14.7006 30.4788Z",
    fill: "#414042"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 26.6562H46.3125",
    stroke: "#DFDFDF",
    strokeWidth: 2.0226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 33.4062V35.9375C44.625 36.1613 44.5361 36.3759 44.3779 36.5341C44.2196 36.6924 44.005 36.7813 43.7813 36.7813H41.25C41.0262 36.7813 40.8116 36.6924 40.6534 36.5341C40.4951 36.3759 40.4062 36.1613 40.4062 35.9375V33.4062",
    stroke: "#DFDFDF",
    strokeWidth: 2.0226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5937 33.4062V35.9375C28.5937 36.1613 28.5049 36.3759 28.3466 36.5341C28.1884 36.6924 27.9738 36.7813 27.75 36.7813H25.2187C24.995 36.7813 24.7804 36.6924 24.6221 36.5341C24.4639 36.3759 24.375 36.1613 24.375 35.9375V33.4062",
    stroke: "#DFDFDF",
    strokeWidth: 2.0226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 30.0312H29.4375",
    stroke: "#DFDFDF",
    strokeWidth: 2.52825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5625 30.0312H41.25",
    stroke: "#DFDFDF",
    strokeWidth: 2.52825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 26.6562L41.4715 19.5687C41.406 19.4188 41.2984 19.2911 41.1617 19.2012C41.025 19.1114 40.8652 19.0632 40.7016 19.0625H28.2984C28.1348 19.0632 27.975 19.1114 27.8383 19.2012C27.7016 19.2911 27.594 19.4188 27.5285 19.5687L24.375 26.6562V33.4062H44.625V26.6562Z",
    stroke: "#DFDFDF",
    strokeWidth: 2.0226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.1032bb737cd4c0d01d5b410a4552fa97.svg";
export { ForwardRef as ReactComponent };